module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "theme skin",
    class: _vm.themeNamespace
  }, [_c('keep-alive', [_c(_vm.layout, {
    tag: "component",
    staticClass: "layout"
  }, [_c(_vm.module(), {
    tag: "component",
    staticClass: "module",
    class: _vm.className
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc22b4c4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/shell/index.vue
// module id = ikoX
// module chunks = 13 14